import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'text', 'value'];

  // action="submit->inline-form#submit"
  async submit(event) {
    event.preventDefault();

    let response;
    try {
      response = await fetch(this.element.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        // _method と authenticity_token は form_with が hidden で入れている
        body: new FormData(this.element),
      });
    } catch (error) {
      console.error(error);
      alertify.error('更新に失敗しました');
      this.changeTextView();
      return;
    }

    const data = await response.json().catch(() => null);
    if (response.ok && data) {
      alertify.success('変更しました');
      const target = this.hasValueTarget ? this.valueTarget : this.textTarget;
      target.textContent = data.val;
    } else {
      alertify.error(data?.msg || '更新に失敗しました');
    }
    this.changeTextView();
  }

  changeEditView() {
    this.inputTarget.style.display = 'block';
    this.textTarget.style.display = 'none';
  }

  changeTextView() {
    this.inputTarget.style.display = 'none';
    this.textTarget.style.display = 'block';
  }
}
